import React, { useState } from 'react';
import TextField from '@mui/material/TextField';

const FormInputMaterialTest = ({ register, error = false, label, id, ...inputProps }) => {
  const height = 44;
  const val = inputProps.value ?? inputProps.defaultValue;
  const hasValue = val !== undefined && val !== null && val !== '';
  return (
    <>
      {inputProps.type !== "hidden" && <label htmlFor={id}>{label}</label>}
      <TextField
        id={id}
        type={inputProps.type || 'text'}
        className={`form-control ${error ? "_is-invalid" : ""}`}
        variant={inputProps.variant || "outlined"}
        error={error.message ? true : false}
        style={{ height }}
        label={inputProps.placeholder || inputProps.label}
        {...register(id)}
        // {...inputProps}
        multiline={inputProps.multiline || false}
        InputLabelProps={{
          shrink: hasValue ? true : undefined,
          style: {
            height,
            lineHeight: '0.85rem',
            fontSize: '14px',
          },
        }}
        /* styles the input component */
        inputProps={{
          step: inputProps.type === 'number' ? (inputProps.step || 'any') : null,
          min: inputProps.min ? inputProps.min : null,
          max: inputProps.max ? inputProps.max : null,
          inputMode: inputProps.inputMode ? inputProps.inputMode : null,
          pattern: inputProps.pattern ? inputProps.pattern : null,
          style: {
            height,
            padding: '0 10px',
          },
        }}
      />
      {error && <div className="invalid-feedback">{error.message}</div>}
    </>
  );
};
export default FormInputMaterialTest;
